import {
  IScopeChildren,
  IScopeDescendents,
  IScopeSelf,
  IScopeNone,
  IScopeAll,
} from '../types/utils'

import {
  IField_HasRolesMode_All,
  IField_HasRolesMode_Any,
} from '../types/schema/role'

import {
  INode_EntityRole_Origin_Type_Org,
  INode_EntityRole_Origin_Type_User,
  INode_EntityRole_Origin_Type_Org_Persona,
  INode_EntityRole_Origin_Type_User_Persona,
} from '../types/schema/tree'

import {
  IExport_Persona_Origin_Config,
  IExport_Persona_Origin_User,
  IExport_EntityPersonaOptions_Type_User,
  IExport_EntityPersonaOptions_Type_Org,
} from '../types/schema/project_config'

/*

  role

*/
export const CHILDREN: IScopeChildren = 'children'
export const DESCENDENTS: IScopeDescendents = 'descendents'
export const SELF: IScopeSelf = 'self'
export const NONE: IScopeNone = 'none'
export const ALL: IScopeAll = 'all'

export const ROLE_SCOPE_SELF = SELF
export const ROLE_SCOPE_CHILDREN = CHILDREN
export const ROLE_SCOPE_DESCENDENTS = DESCENDENTS
export const ROLE_SCOPE_NONE = NONE
export const ROLE_SCOPE_ALL = ALL

export const ROLE_SCOPE_DEFAULT = ROLE_SCOPE_SELF

export const ROLE_SCOPE: string[] = [
  ROLE_SCOPE_SELF,
  ROLE_SCOPE_CHILDREN,
  ROLE_SCOPE_DESCENDENTS,
  ROLE_SCOPE_NONE,
  ROLE_SCOPE_ALL,
]

export const ROLE_SCOPE_LEVELS = {
  [ROLE_SCOPE_NONE]: -1,
  [ROLE_SCOPE_SELF]: 0,
  [ROLE_SCOPE_CHILDREN]: 1,
  [ROLE_SCOPE_DESCENDENTS]: 2,
  [ROLE_SCOPE_ALL]: 3,
}

export const ROLE_SCOPE_TITLES = {
  [ROLE_SCOPE_NONE]: 'None',
  [ROLE_SCOPE_SELF]: 'Only',
  [ROLE_SCOPE_CHILDREN]: 'Plus Children',
  [ROLE_SCOPE_DESCENDENTS]: 'Plus Descendants',
  [ROLE_SCOPE_ALL]: 'Plus All Orgs'
}

export const ROLE_QUERY_HAS_ALL: IField_HasRolesMode_All = 'all'
export const ROLE_QUERY_HAS_ANY: IField_HasRolesMode_Any = 'any'

export const ROLE_ORIGIN_TYPE_ORG: INode_EntityRole_Origin_Type_Org = 'org'
export const ROLE_ORIGIN_TYPE_USER: INode_EntityRole_Origin_Type_User = 'user'
export const ROLE_ORIGIN_TYPE_ORG_PERSONA: INode_EntityRole_Origin_Type_Org_Persona = 'org_persona'
export const ROLE_ORIGIN_TYPE_USER_PERSONA: INode_EntityRole_Origin_Type_User_Persona = 'user_persona'

export const ROLE_TARGET_CHILDREN = CHILDREN
export const ROLE_TARGET_DESCENDENTS = DESCENDENTS
export const ROLE_TARGET_SELF = SELF

export const PERSONA_TYPE_USER: IExport_EntityPersonaOptions_Type_User = 'user'
export const PERSONA_TYPE_ORG: IExport_EntityPersonaOptions_Type_Org = 'org'

export const PERSONA_ORIGIN_CONFIG: IExport_Persona_Origin_Config = 'config'
export const PERSONA_ORIGIN_USER: IExport_Persona_Origin_User = 'user'
